<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-07 09:56:13
 * @LastEditTime: 2020-06-24 11:49:14
 * @LastEditors: maple
 -->
<template>
  <div class="build">
    <a-row>
      <a-col :span="24" style="height: 100vh;">
        <!-- <iframe src="3D/index.html" width="100%" height="99.5%" id="page3D"></iframe> -->

        <div id="container" style="width: 100%;height: 100%;"></div>
        <input
          type
          name
          id="tipinput"
          style="position: absolute;top:40px;left:50%; width:260px;margin-left: -130px; padding-left:10px;box-shadow:  0 0 4px #000; border:0; border-radius: 4px; height:30px; "
          placeholder="搜索位置"
        />

        <a-row id="build_modelChoose">
          <div style="display: flex; justify-content: center;">
            <a-col
              :span="5"
              class="con active"
              @click="toMakeModelPage('map')"
              style="border: 1px solid #ccc;"
            >
              <img
                src="../assets/images/modeling_img_mapOn.png"
                style="width:40px;margin-right: 14px;"
              />
              地图获取建模
            </a-col>
            <a-col
              :span="5"
              class="con"
              @click="toMakeModelPage('machine')"
              style="border: 1px solid #ccc;"
            >
              <img
                src="../assets/images/modeling_img_planeOn.png"
                style="width:40px;margin-right: 14px;"
              />
              无人机图片建模
            </a-col>
            <a-col
              :span="5"
              class="con"
              @click="toMakeModelPage('drawing')"
              style="border: 1px solid #ccc;"
            >
              <img
                src="../assets/images/modeling_img_tzjmOn.png"
                style="width:40px;margin-right: 14px;"
              />
              图纸建模
            </a-col>
          </div>
        </a-row>
        <router-link class="build-detail-btn" to="/BuildList">已有模型</router-link>
      </a-col>
    </a-row> 
    <div class="GoCurrentLocation2" @click="GoSatellite">卫星</div>
    <div class="GoCurrentLocation" @click="GoCurrentLocation()"></div>
     
    <div class="not-gps" v-if="meshNullGPS.length">
       <span>未获取到的GPS设备</span> 
        <font v-for="item in meshNullGPS">{{item.SN}}</font>  
    </div> 
  </div>
</template>

<script scoped>
import { Component, Vue } from "vue-property-decorator";
import BuildService from "../api/BuildService";
export default {
  data() {
    return {
      activeIndex: 0,
      center: [113.861321, 22.571517],
      map: null,
      marker: null,
      InspectMapimer: null,
      satellite: null,
      ISElectron: false,
      roadNet: null,
      mesh:[],
      meshNullGPS:[],
      meshGPS:[]

    };
  },
  computed: {
    CurrentLocation() {
      return this.$store.state.CurrentLocation;
    }
  },
  mounted() {
    try {
      this.ISElectron = ipc && ipc.electron ? true : false;
    } catch {}

    this.InspectMap();
  },
  methods: {
    InspectMap() {
      let ISMAP = false;
      try {
        if (AMap) {
          ISMAP = true;
          this.init();
          this.getMesh()
        }
      } catch {}
      if (ISMAP == false) {
        this.InspectMapimer = setTimeout(() => {
          this.InspectMap();
        }, 2000);
      }
    },
    getMesh(){
      for (let i = 0; i < this.mesh.length; i++) {
        if(this.mesh[i].GPS == undefined || this.mesh[i].GPS == null){
          this.meshNullGPS.push(this.mesh[i])
        }else{
          this.meshGPS.push(this.mesh[i])
        }
      }

      for (let i = 0; i < this.meshGPS.length; i++) {  
        
        var text = new AMap.Text({
          text:this.meshGPS[i].SN,
          anchor:'center', // 设置文本标记锚点
          draggable:true,
          cursor:'pointer', 
          style:{ 
              padding:'6px'
          },
          position: [this.meshGPS[i].GPS.Lng,this.meshGPS[i].GPS.Lat]
        }); 
        text.setLabel({ 
          border:0,
          content:this.meshGPS[i].IP, //设置文本标注内容
          direction: 'bottom', //设置文本标注方位 
        })
        text.setMap(this.map)  
        let _this = this
        text.on('click',function(){
          _this.$router.push({ name: "Mesh"})
        })

        var path  
        for (var j = 0; j < this.meshGPS.length; j++) {
          if(this.meshGPS[j].MAC == this.meshGPS[i].SuperiorMAC){
            path =[[this.meshGPS[i].GPS.Lng,this.meshGPS[i].GPS.Lat],[this.meshGPS[j].GPS.Lng,this.meshGPS[j].GPS.Lat]]
          }
        }
 
        /*var marker = new AMap.Marker({
          offset: new AMap.Pixel(-25, -50),
          content: '<div class="t"></div>',
          position: [this.meshGPS[i].GPS.Lng,this.meshGPS[i].GPS.Lat],
          map: this.map, 
          draggable: true,
          angle:90
        });*/

        var strokeColor ='#E85245'
        if(this.meshGPS[i].RSSI > -70){
          strokeColor = '#9391ED'
        }else if(this.meshGPS[i].RSSI <= -70 && this.meshGPS[i].RSSI > -90){
          strokeColor ='#67F563'
        }else if(this.meshGPS[i].RSSI <= -90 && this.meshGPS[i].RSSI > -105){
          strokeColor ='#FFC672'
        }else if(this.meshGPS[i].RSSI <= -105 && this.meshGPS[i].RSSI > -120){
          strokeColor ='#D87856'
        }else{
          strokeColor ='#E85245'
        }

        var polyline = new AMap.Polyline({
          path: path, 
          lineCap:'round',
          strokeColor: strokeColor, 
          strokeOpacity: 1,
          strokeWeight: 2, 
          strokeStyle: "solid" 
        })
        polyline.setMap(this.map)


        var text = new AMap.Text({
          text:'('+this.meshGPS[i].RSSI+','+this.meshGPS[i].TransmissionRate+','+this.meshGPS[i].ConnectionRate+')',
          anchor:'center', // 设置文本标记锚点
          draggable:false, 
          style:{ 
              padding:'6px',
              border:0,
              background:'none'
          },
          position: [(this.meshGPS[i].GPS.Lng + this.meshGPS[i+1].GPS.Lng)/2,(this.meshGPS[i].GPS.Lat+this.meshGPS[i+1].GPS.Lat)/2]
        });
        text.setMap(this.map) 

 
        
      }
 
      
    }, 

    init() {
      if (
        this.CurrentLocation &&
        this.CurrentLocation.Lat &&
        this.CurrentLocation.Lng
      ) {
        this.center = [this.CurrentLocation.Lng, this.CurrentLocation.Lat];
      }
      let that = this;
      this.satellite = new AMap.TileLayer.Satellite({ zIndex: 99 });
     
      this.map = new AMap.Map("container", {
        viewMode: "3D",
        expandZoomRange: true,
        rotateEnable: true,
        pitchEnable: true,
        zooms: [1, 20],
        rotation: 0,
        showBuildingBlock: false,
        pitch: 45,
        zoom: 20,
        center: this.center
      });
      let map = this.map;
      AMap.plugin(["AMap.ControlBar"], function() {
        let toolbar = new AMap.ToolBar({
          visible: false
        });
        let controlBar = new AMap.ControlBar();
        map.addControl(toolbar);
        // 添加 3D 罗盘控制
        map.addControl(controlBar);
      });

      let auto = new AMap.Autocomplete({
        input: "tipinput",
        select: function(result) {}
      });

      let marker = new AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: this.center,
        draggable: true
      });
      marker.setMap(map);

      marker.on("dragend", function() {
        that.center = marker.getPosition();
      });
      this.marker = marker;
      auto.on("select", function(result) {
        map.remove(marker);
        that.center = result.poi.location;
        map.setCenter(result.poi.location);
        that.marker.setPosition(result.poi.location);
        marker.setMap(map);
        marker.on("dragend", function() {
          that.center = marker.getPosition();
        });
      });
      this.BrowserLocation();
    },
    //浏览器定位
    BrowserLocation() {
      let self = this;
      AMap.plugin("AMap.Geolocation", function() {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          showButton: false,
          zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          showMarker: false
        });
        self.map.addControl(geolocation);
        geolocation.getCurrentPosition(function(status, result) {
          if (status == "complete") { 
            //console.log(result.position)
            self.marker.setPosition(result.position); 
          } else {
            console.error(result);
          }
        });
      });
    },
    GoCurrentLocation() {
      let self = this;
      if (this.ISElectron) {
        let gpsinfo = ipc.GetGpsInfo();
        console.info(gpsinfo);
        if (gpsinfo.GPSState != 1 && gpsinfo.GPSState != 2) {
          if (gpsinfo.GPSState == -1) {
            this.$message.warning("当前设备无GPS设备,或GPS设备被其它程序占用");
          } else {
            this.$message.warning("GPS尚未定位,请保证设备在开阔地方");
          }
        } else {
          let gps = [gpsinfo.GPSLng, gpsinfo.GPSLat];
          AMap.convertFrom(gps, "gps", function(status, result) {
            if (result.info === "ok") {
              var lnglats = result.locations; // Array.<LngLat>
              console.info(result);
              self.map.setCenter(lnglats[0]);
              self.marker.setPosition(lnglats[0]);
            }
          });
        }
      } else {
        this.BrowserLocation();
      }
    },
    GoSatellite(e) {
      if (e.target.innerHTML == "卫星") {
        this.satellite.setMap(this.map);
        e.target.innerHTML = "标准";
      } else {
        e.target.innerHTML = "卫星";
        this.satellite.setMap(null);
      }
    },
    toMakeModelPage(type) { 
      switch (type) {
        case "map":
        case "machine":
          this.$router
            .push({
              name: "buildMake",
              query: { type, location: JSON.stringify(this.marker.getPosition())}
            })
            .catch(err => {
              console.error(err);
            });
          break;
        case "drawing":
          this.$router
            .push({
              name: "buildMake",
              query: { type: "machine", location: this.marker.getPosition() }
            })
            .catch(err => {
              console.error(err);
            });
          break;
        default:
          this.$notification.open({
            message: "信息",
            description: "暂未开放，敬请期待",
            duration: 3
          });
          break;
      }
    }
  },
  beforeDestroy() {
    if (this.InspectMapimer) {
      clearInterval(this.InspectMapimer);
    }
  }
};
</script>
<style lang="less" scoped>
.build-detail-btn {
  display: block;
  width: 80px;
  height: 80px;
  background: #40dc23;
  border-radius: 50%;
  font-size: 20px;
  padding: 10px 20px;
  color: #fff;
  position: absolute;
  right: 130px;
  top: 60px;
}

#build_modelChoose {
  width: 100%;

  position: absolute;
  bottom: 0;
}
#build_modelChoose .con {
  background-color: #576371;
  height: 80px;
  text-align: center;
  line-height: 80px;
  color: #fff;
  cursor: pointer;
}

#build_modelChoose .active {
  background-color: #3fdb23;
}

#buildIframe {
  border: 0;
  margin: 0;
  padding: 0;
}
.GoCurrentLocation {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 40px;
  bottom: 80px;
  z-index: 9999;
  border-right: 2px;
  background: #fff url("../assets/images/location.png") no-repeat center;
  cursor: pointer;
  box-shadow: 1px 1px 5px #ccc;
}
.GoCurrentLocation2 {
    width: 50px;
    height: 50px;
    background: #fff;
    position: fixed;
    right: 40px;
    bottom: 140px;
    z-index: 9999;
    border-right: 2px;
    cursor: pointer;
    text-align: center;
    line-height: 50px;
    font-size: 17px;
    box-shadow: 1px 1px 5px #ccc;
}
.mesh-box{
  color:#000;
  position: absolute;
  top:50px;
  left:120px;
  span{
    display: inline-block;
    height:2px;
    width:60px; 
    float: left;
    margin: 10px 4px 0 0 ; 
  }
}

 
</style>